function CheckIcon({ width = '15', height = '11.29', fill = '#ffffff' }) {
  return (
    <svg
      id="checkmark"
      width={width}
      height={height}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.375 6.867L0 3.613l1.047-1.081 2.308 2.212L7.934.06 9 1.12z" fillRule="evenodd" />
    </svg>
  );
}

export default CheckIcon;
